export default __webpack_public_path__ + "static/media/doodle.353f97de.svg";